export default "__VITE_ASSET__b7a1dc47__"